<main>
  <div class="content-container">
    <app-error-form
      [errorMessage]="errorMessage"
      [validationErrorMessages]="validationErrorMessages"
    ></app-error-form>
    <div class="flex flex-col gap-6">
      <kendo-card>
        <form [formGroup]="form" class="mb-0">
          <div class="flex items-center gap-6">
            <h1 class="flex-1 m-0 pb-3 text-[20px] font-medium text-black">
              {{ "issuePaymentAdd" | translate }}
            </h1>
            <div class="flex items-center justify-center">
@if (actionMenuOptions.length) {
              <app-actions-dropdown
                [data]="actionMenuOptions"
                (itemClick)="openCurrencyInfoAddDrawer()"
              ></app-actions-dropdown>
              }
            </div>
          </div>
          <section class="flex gap-6 py-3">
            <!-- Paid To Contact -->
            <app-contacts-dropdown
              class="basis-[50%]"
              [parentForm]="form"
              title="{{ 'paidTo' | translate }}*"
              [controlName]="'paidToContactUid'"
              createKey="Supplier"
              [filter]="contactFilter"
              (customerSelect)="onContactValueChange($event)"
            >
              @if (
                form.controls.paidToContactUid.errors?.required &&
                showValidation
              ) {
                <kendo-formerror>{{
                  "contactIsRequired" | translate
                }}</kendo-formerror>
              }
            </app-contacts-dropdown>
            <!-- Date -->
            <app-date-calendar
              class="basis-[50%]"
              title="{{ 'date' | translate }}*"
              [parentForm]="form"
              [controlName]="'date'"
              [showValidation]="showValidation"
            >
            </app-date-calendar>
          </section>

          <section class="flex gap-6 py-3">
            <!-- Payment Account -->
            <app-accounts-dropdown
              class="basis-[50%]"
              [parentForm]="form"
              [controlName]="'paidFromAccountUid'"
              title="{{ 'paymentAccount' | translate }}*"
              [filter]="accountFilter"
            >
            </app-accounts-dropdown>
            <app-payment-method-dropdown
              class="basis-[50%]"
              [parentForm]="form"
              controlName="paymentMethod"
              [title]="'paymentMethod' | translate"
            ></app-payment-method-dropdown>
          </section>

          <ng-template #projectDropdown>
            @if (isCompanyProjectLinked) {
              <app-company-project-dropdown
                [parentForm]="form"
                controlName="projectUid"
              ></app-company-project-dropdown>
            }
          </ng-template>
          @if (!allowDualCurrency) {
            <section class="flex gap-6 py-3">
              <div class="basis-[50%]">
                <ng-container
                  *ngTemplateOutlet="projectDropdown"
                ></ng-container>
              </div>
              <div class="basis-[50%]">
                <ng-container>
                  <ng-container
                    *ngTemplateOutlet="baseAmountField"
                  ></ng-container>
                </ng-container>
              </div>
            </section>
          }

          <ng-template #baseAmountField>
            <!-- Base Amount -->
            <div class="flex-col">
              <kendo-formfield>
                <kendo-label
                  [text]="(paymentCurrencyUid || baseCurrencyUid) + ' ' + ('amount' | translate) + '*'"
                >
                  <kendo-numerictextbox
                    [min]="0"
                    [decimals]="2"
                    [formControlName]="'baseAmount'"
                    [spinners]="false"
                  ></kendo-numerictextbox>
                </kendo-label>
                @if (isAmountRequired("baseAmount")) {
                  <kendo-formerror
                    >{{ "amountIsRequired" | translate }}
                  </kendo-formerror>
                }
              </kendo-formfield>
              @if (
                isAmountInvalid("baseAmount") && !isAmountRequired("baseAmount")
              ) {
                <kendo-formerror
                  >{{
                    "amountCannotBeNegativeOrSmallerThanTheTotalAmountsBelow"
                      | translate
                  }}
                </kendo-formerror>
              }
              <div class="flex justify-between unalloted-container">
                <p class="unalloted-text">
                  {{ "unallocated" | translate }} {{ paymentCurrencyUid || baseCurrencyUid }}
                  {{ "amount" | translate }}
                </p>
                <p class="unalloted-amount">
                  <app-currency-total
                    [currencyUid]="paymentCurrencyUid || baseCurrencyUid"
                    [totalAmount]="
                      form.value.baseAmount -
                      invoicesGrid?.totalPayment.baseAmount
                    "
                  ></app-currency-total>
                </p>
              </div>
            </div>
          </ng-template>

          @if (allowDualCurrency) {
            <section class="flex gap-6 py-3">
              <div class="basis-[50%]">
                <ng-container
                  *ngTemplateOutlet="baseAmountField"
                ></ng-container>
              </div>
              <!-- Base Amount 2 -->
              <div class="flex-col basis-[50%]">
                <kendo-formfield>
                  <kendo-label
                    [text]="
                      baseCurrencyUid2 + ' ' + ('amount' | translate) + '*'
                    "
                  >
                    <kendo-numerictextbox
                      [min]="0"
                      [decimals]="2"
                      [formControlName]="'baseAmount2'"
                      [spinners]="false"
                    ></kendo-numerictextbox>
                  </kendo-label>
                  @if (isAmountRequired("baseAmount2")) {
                    <kendo-formerror
                      >{{ "amountIsRequired" | translate }}
                    </kendo-formerror>
                  }
                </kendo-formfield>
                @if (
                  isAmountInvalid("baseAmount2") &&
                  !isAmountRequired("baseAmount2")
                ) {
                  <kendo-formerror
                    >{{
                      "amountCannotBeNegativeOrSmallerThanTheTotalAmountsBelow"
                        | translate
                    }}
                  </kendo-formerror>
                }
                @if (parityRateDeviation) {
                  <kendo-formerror>
                    {{
                      "amountDoesNotMatchTheMaintainedParityRate"
                        | translate
                          : {
                              currency: baseCurrencyUid2,
                              implied: parityRateDeviation.implied,
                              maintained: parityRateDeviation.maintained
                            }
                    }}
                  </kendo-formerror>
                }
                <div class="flex justify-between unalloted-container">
                  <p class="unalloted-text">
                    {{ "unallocated" | translate }} {{ baseCurrencyUid2 }}
                    {{ "amount" | translate }}
                  </p>
                  <p class="unalloted-amount">
                    <app-currency-total
                      [currencyUid]="baseCurrencyUid2"
                      [totalAmount]="
                        form.value.baseAmount2 -
                        invoicesGrid?.totalPayment.baseAmount2
                      "
                    ></app-currency-total>
                  </p>
                </div>
              </div>
            </section>
          }

          @if (allowDualCurrency) {
            <section class="flex gap-6 py-3">
              <div class="basis-[50%]">
                <ng-container
                  *ngTemplateOutlet="projectDropdown"
                ></ng-container>
              </div>
              <div class="basis-[50%]"></div>
            </section>
          }
          <!-- ZEY-2655/2658: a payment in neither base currency, and a paying account in a third one -->
          @if (supplierCurrencyUid) {
            <p class="m-0 pt-1 text-[13px] text-gray-600">
              {{ "paymentCurrencySetBySupplier" | translate: { currency: supplierCurrencyUid } }}
            </p>
          }
          @if (isForeignPayment || needsPaidFromAmount) {
            <section class="flex gap-6 py-3">
              @if (isForeignPayment) {
                <div class="flex-col basis-[50%]">
                  <kendo-formfield>
                    <kendo-label
                      [text]="('amountInCurrency' | translate: { currency: baseCurrencyUid }) + '*'"
                    >
                      <kendo-numerictextbox
                        [min]="0"
                        [decimals]="2"
                        [formControlName]="'amountInBaseCurrency'"
                        [spinners]="false"
                      ></kendo-numerictextbox>
                    </kendo-label>
                    @if (impliedRateText) {
                      <kendo-formhint>{{ impliedRateText }}</kendo-formhint>
                    }
                    @if (form.controls.amountInBaseCurrency.errors?.required && showValidation) {
                      <kendo-formerror>{{ "amountIsRequired" | translate }}</kendo-formerror>
                    }
                  </kendo-formfield>
                </div>
              }
              @if (needsPaidFromAmount) {
                <div class="flex-col basis-[50%]">
                  <kendo-formfield>
                    <kendo-label
                      [text]="('amountPaidFromAccountIn' | translate: { currency: paidFromCurrencyUid }) + '*'"
                    >
                      <kendo-numerictextbox
                        [min]="0"
                        [decimals]="2"
                        [formControlName]="'paidFromAmount'"
                        [spinners]="false"
                      ></kendo-numerictextbox>
                    </kendo-label>
                    @if (paidFromRateText) {
                      <kendo-formhint>{{ paidFromRateText }}</kendo-formhint>
                    }
                    @if (form.controls.paidFromAmount.errors?.required && showValidation) {
                      <kendo-formerror>{{ "amountIsRequired" | translate }}</kendo-formerror>
                    }
                  </kendo-formfield>
                </div>
              }
            </section>
          }
        </form>
      </kendo-card>
      <kendo-card>
        <app-invoices-grid
          #invoicesGrid
          [data]="gridData"
          [parentCurrencyUid]="form.value.currencyUid"
          [parityRate]="parityRate"
          [isLoading]="isLoading"
          [invoiceType]="invoiceType"
          [voucherAmount]="form.value.baseAmount"
          [voucherBaseRate]="voucherBaseRate"
        ></app-invoices-grid>
        <!-- Memo -->
        <div class="flex gap-6">
          <app-textarea-input
            class="basis-[50%]"
            label="{{ 'note' | translate }}"
            [parentForm]="form"
            [controlName]="'memo'"
          ></app-textarea-input>
          <span class="basis-[50%]"></span>
        </div>
      </kendo-card>
    </div>
  </div>

  <app-action-bar
    [isBoxShadow]="false"
    [isWaiting]="isWaiting"
    [screenType]="'Form'"
    [actionsOptions]="[
      {
        visible: true,
        class: 'btn-primary',
        label: 'Save and Close',
        labelName: ('saveAndClose' | translate),
        options: [{ text: ('saveAndNew' | translate), value: 'Save and New' }]
      },
      {
        visible: true,
        class: 'btn-outline-secondary',
        label: 'Discard',
        labelName: ('discard' | translate)
      }
    ]"
    (buttonClick)="onActionClick($event, 'add')"
  >
  </app-action-bar>
</main>
